import React from 'react';
import { useSelector } from 'react-redux';

import Map from '../components/Map';

const MapContainer = () => {
  const { gpxPoints, gpxCoordinates, snappedCoordinates } = useSelector((state) => state.map.data);

  return <Map gpxPoints={gpxPoints} gpxCoordinates={gpxCoordinates} snappedCoordinates={snappedCoordinates} />;
};

export default MapContainer;
